import * as JsStore from 'jsstore';
import * as JsStoreWorker from 'jsstore/dist/jsstore.worker.commonjs2';
window['JsStoreWorker'] = JsStoreWorker;
export const connection = new JsStore.Connection();

// connection.logStatus = true;